import {ChangeDetectionStrategy, Component} from '@angular/core';
import {BaseFieldType} from '../base-field-type';
import {NbRadioModule} from "@nebular/theme";
import {NgForOf, NgIf} from "@angular/common";
import {FormlyModule} from "@ngx-formly/core";

@Component({
    selector: 'app-radio-filter-property',
    templateUrl: './radio-filter-property.component.html',
    imports: [
        NbRadioModule,
        NgIf,
        FormlyModule,
        NgForOf
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class RadioFilterPropertyComponent extends BaseFieldType {

  onChange(value, checked) {
    console.log(value);
    console.log(checked);
    console.log(this.formControl.value);
    if (value !== 0) {
      this.formControl.patchValue(Object.assign({}, this.formControl.value, {[value]: checked}));
    } else {
      this.formControl.patchValue(Object.assign({}, this.formControl.value, null));
    }
    this.formControl.markAsTouched();

  }

  isChecked(option) {
    const value = this.formControl.value;
    console.log(option.value);
    console.log(value);
    return value && option.value === value;
  }

  isCheckedAll() {
    const value = this.formControl.value;
    return 0 === value;
  }

}
